import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  DotsWrapper,
  LinearProgressStyled,
  ProgressText,
  Wrapper,
} from "./ProgressBar.styled";

const ProgressBar = ({ onFinish }) => {
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const [dots, setDots] = useState("");

  const { t } = useTranslation();
  const timerId = useRef(null);
  const dotsTimerId = useRef(null);

  useEffect(() => {
    if (progress < 100) {
      timerId.current = setInterval(() => {
        setProgress(prevProgress => prevProgress + 1);
      }, 35);
    } else {
      clearInterval(timerId.current);

      dotsTimerId.current = setInterval(() => {
        setDots(prevDots => (prevDots.length < 3 ? prevDots + "." : ""));
      }, 300);

      setIsComplete(true);

      setTimeout(() => {
        if (onFinish) onFinish();
      }, 500);
    }

    return () => {
      clearInterval(timerId.current);
      clearInterval(dotsTimerId.current);
    };
  }, [progress, onFinish]);

  return (
    <Wrapper>
      <LinearProgressStyled progress={progress} />
      <ProgressText>
        {t("global.loading")}
        <DotsWrapper>{isComplete ? dots : "..."}</DotsWrapper>
      </ProgressText>
    </Wrapper>
  );
};

export { ProgressBar };
